import { render } from "./CounterRecordInfo.vue?vue&type=template&id=ab651998&ts=true"
import script from "./CounterRecordInfo.vue?vue&type=script&lang=ts"
export * from "./CounterRecordInfo.vue?vue&type=script&lang=ts"

import "./CounterRecordInfo.vue?vue&type=style&index=0&id=ab651998&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__